import React, { Component } from 'react';
import {
	BrowserRouter as Router,
	NavLink,
} from 'react-router-dom';
import RetinaImage from 'react-retina-image';

import Routes from './Routes';

import logoImg from '../assets/img/sjukmat_logo.png';
import aboutImg from '../assets/img/om_sjukmat2.png';
import sparkleImg from '../assets/img/sparkle.png';
import petitionImg from '../assets/img/namninsamling.png';
import logoImgRetina from '../assets/img/sjukmat_logo@2x.png';
import aboutImgRetina from '../assets/img/om_sjukmat2@2x.png';
import sparkleImgRetina from '../assets/img/sparkle@2x.png';
import petitionImgRetina from '../assets/img/namninsamling@2x.png';

import '../assets/css/app.css';

class App extends Component {

	render() {

		return (
			<Router>
				<div className="wrapper">
					<div className="header">
						<div className="row">
							<div className="col">
								<NavLink to="om" style={{display:'block', marginTop: 35, marginLeft:15}}>
									<RetinaImage alt="#sjukmat" src={[aboutImg, aboutImgRetina]} />
								</NavLink>
							</div>

							<div className="col align-center">
								<NavLink to="/">
									<RetinaImage alt="sjukmat logo" src={[logoImg, logoImgRetina]} />
								</NavLink>
							</div>

							<div className="col align-right">
								{/* <NavLink to="namninsamling" style={{display:'block', marginTop: 50, marginRight:15}}>
									<RetinaImage alt="Namninsamling" src={[petitionImg, petitionImgRetina]} />
								</NavLink> */}
							</div>
						</div>
					</div>

					<div className="header-mobile">
						<div className="row">
							<div className="col">
								<NavLink to="/">
									<RetinaImage alt="sjukmat logo" src={[logoImg, logoImgRetina]} />
								</NavLink>
							</div>

							<div className="col-two-thirds align-right">
								<NavLink to="om" style={{display:'block', marginTop: 10, marginLeft:15}}>
									<RetinaImage alt="#sjukmat" src={[aboutImg, aboutImgRetina]} />
								</NavLink>
								<NavLink to="namninsamling" style={{display:'block', marginTop: 13, marginLeft:15}}>
									<RetinaImage alt="Namninsamling" src={[petitionImg, petitionImgRetina]} />
								</NavLink>
							</div>
						</div>
					</div>

					<Routes />
				
					<div className="footer">
						<div className="col-full align-center" style={{display: 'block'}}>
							<a href="https://getsparkle.io/">
								<RetinaImage alt="Sparkle" src={[sparkleImg, sparkleImgRetina]} />
							</a>
						</div>
					</div>
				</div>
			</Router>
		);
	}
}

export default App;


// WEBPACK FOOTER //
// ./src/components/App.js